<template>
  <div :style="{ padding: '12px', minHeight: '360px' }">
    <a-bread-crumb />
    <a-dashboard-overview v-if="belongsToOrg" />
    <a-no-tenant v-else />
  </div>
</template>
<script>
import ADashboardOverview from "@/components/dashboard/ADashboardOverview";
import ANoTenant from "@/components/dashboard/ANoTenant";

export default {
  name: "app",
  components: {
    ADashboardOverview,
    ANoTenant
  },
  computed: {
    belongsToOrg() {
      return this.$auth.session.org && this.$auth.session.org !== "false"
        ? true
        : false;
    }
  }
};
</script>

<style>
.logo {
  width: 50px;
  height: auto;
}
</style>
